import { narusGrey5 } from '../../../../../../shared/NarusMaterial/colors.js'

export const style = {
  radioButton: {
    display: 'inline-block',
    width: '5rem'
  },
  radioGroup: {
    display: 'inline-block',
    verticalAlign: 'middle'
  },
  inputStyle: {
    width: '100%'
  },
  saveButton: {
    marginLeft: '1rem'
  },
  subHead: {
    color: `${narusGrey5}`
  },
  checkbox: {
    display: 'inline-block',
    width: '100px'
  },
  marg: {
    marginTop: '1rem'
  }
}
